import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=12b1c1b9&scoped=true&"
import script from "./TemplateModal.vue?vue&type=script&lang=js&"
export * from "./TemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&id=12b1c1b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1c1b9",
  null
  
)

export default component.exports